module.exports = __webpack_public_path__ + "img/flag_openrun.bc17aac.svg";